import { useEffect } from "react";

export const SITE_URL = "https://dnafinance.co.uk";
const SITE_NAME = "DNA Finance";
const DEFAULT_DESC = "DNA Finance is a UK commercial finance broker with access to 165+ lenders. Asset finance, commercial mortgages, bridging, development, invoice finance and business loans arranged nationwide.";

function setMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.tag || "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => k !== "tag" && el.setAttribute(k, v));
}

const normalise = (p) => (p.length > 1 ? p.replace(/\/+$/, "") : "/");

export function Seo({ title, description = DEFAULT_DESC, path = "/", jsonLd, noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | UK Commercial Finance Broker`;
    const url = `${SITE_URL}${normalise(path)}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', { name: "description", content: description });
    setMeta('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, nofollow" : "index, follow, max-snippet:-1, max-image-preview:large" });
    setMeta('link[rel="canonical"]', { tag: "link", rel: "canonical", href: url });
    setMeta('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    setMeta('meta[property="og:description"]', { property: "og:description", content: description });
    setMeta('meta[property="og:url"]', { property: "og:url", content: url });
    setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });

    const id = "page-jsonld";
    document.getElementById(id)?.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = id;
      s.text = JSON.stringify(jsonLd).replace(/</g, "\\u003c");
      document.head.appendChild(s);
    }
    return () => document.getElementById(id)?.remove();
  }, [title, description, path, jsonLd, noindex]);
  return null;
}

export const ORG_REF = { "@type": "FinancialService", "@id": `${SITE_URL}/#organization`, name: SITE_NAME, url: SITE_URL };

export const breadcrumbs = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE_URL}${it.path}` })),
});
